import { Box, Button, Radio, RadioGroup, Stack, Typography } from '@mui/joy';
import { Plus } from '@phosphor-icons/react';
import { ReactNode } from 'react';

import { Level, Variant } from 'theme/enums';

interface IProps {
  title: string;
  allValue: boolean;
  onAllChange: (value: boolean) => void;
  onAdd: () => void;
  allLabel: string;
  customLabel: string;
  addButtonLabel: string;
  children: ReactNode;
  disabled?: boolean;
}

enum RadioValue {
  ALL = 'all',
  CUSTOM = 'custom',
}

export const Section = ({
  title,
  allValue,
  onAllChange,
  allLabel,
  customLabel,
  addButtonLabel,
  children,
  onAdd,
  disabled = false,
}: IProps) => {
  const handleOnAllChange = (value: RadioValue) => {
    onAllChange(value === RadioValue.ALL);

    if (value === RadioValue.CUSTOM) {
      onAdd();
    }
  };

  return (
    <Box>
      <Typography level={Level.TITLE_MD} sx={{ my: 2 }}>
        {title}
      </Typography>
      <RadioGroup
        value={allValue ? RadioValue.ALL : RadioValue.CUSTOM}
        onChange={(e) => handleOnAllChange(e.target.value as RadioValue)}
      >
        <Radio value={RadioValue.ALL} label={allLabel} disabled={disabled} />
        <Radio value={RadioValue.CUSTOM} label={customLabel} disabled={disabled} />
      </RadioGroup>

      {!allValue && (
        <Stack gap={1} sx={{ mt: 2 }}>
          {children}

          <Button
            variant={Variant.PLAIN}
            startDecorator={<Plus />}
            onClick={onAdd}
            sx={{ alignSelf: 'flex-start' }}
          >
            {addButtonLabel}
          </Button>
        </Stack>
      )}
    </Box>
  );
};
